export enum LocaleUrlSegment {
    Locale = 'locale',
}
